document.addEventListener("DOMContentLoaded", function() {
  // Activate the carousel
  var carouselElement = document.getElementById('carouselExampleSlidesOnly');
  if (carouselElement) {
    var carousel = new bootstrap.Carousel(carouselElement, {
      interval: 3000 // Set autoplay interval to 3000 milliseconds (3 seconds)
    });
  }
});
